export default __webpack_public_path__ + "static/media/introductionPicture3.2968b401.png";